import UserNotification from "util/UserNotification";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import { AuthenticationActions } from "stores/authentication/AuthenticationStore";
export default (payload, formValues, backendId, backendGroupSyncIsActive, serviceType, shouldUpdateGroupSync = true) => {
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const notifyOnSuccess = () => UserNotification.success("Authentication service was updated successfully.", "Success");
  const notifyOnError = (error) => UserNotification.error(`Updating authentication service failed with status: ${error}`, "Error");
  return AuthenticationActions.update(backendId, {
    ...payload,
    id: backendId
  }).then((result) => {
    if (enterpriseGroupSyncPlugin && shouldUpdateGroupSync) {
      return enterpriseGroupSyncPlugin.actions.onDirectoryServiceBackendUpdate(backendGroupSyncIsActive, formValues, backendId, serviceType).then(notifyOnSuccess).then(() => result);
    }
    notifyOnSuccess();
    return result;
  }).catch((error) => {
    notifyOnError(error);
    throw error;
  });
};
